// extracted by mini-css-extract-plugin
export default {"Event":"eventDesc__Event__zChxe","EventDetails":"eventDesc__EventDetails__XSXgE"};